import { BIMAGES } from '../data/database';

const getImage = (imageIds) => {
    if (imageIds && imageIds.length) {
        return BIMAGES.filter(im => im?.id?.toUpperCase() == imageIds[0]?.toUpperCase())[0]?.image;
    }

    return null;
}

export default getImage;
